module.exports = now

function now() {
    return new Date().getTime()
}



//////////////////
// WEBPACK FOOTER
// ../~/date-now/index.js
// module id = ../node_modules/date-now/index.js
// module chunks = 0